import React, { useEffect, useRef } from "react";

interface ClickAwayListenerProps {
    onClickAway: () => void; // Function to call when a click outside occurs
    children: React.ReactNode; // Elements wrapped inside the component
}

const ClickAwayListener: React.FC<ClickAwayListenerProps> = ({
    onClickAway,
    children,
}) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            // Check if the click happened outside the wrapped element
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target as Node)
            ) {
                onClickAway(); // Trigger the callback when clicked outside
            }
        };

        // Add event listener when the component mounts
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClickAway]);

    return <div ref={wrapperRef}>{children}</div>;
};

export default ClickAwayListener;
